export default __webpack_public_path__ + "static/media/faq_1_img_3.157147c4.svg";